import React from 'react'
import PropTypes from 'prop-types'

import timeAxis from 'components/Chart/axies/time'
import Chart from 'components/Chart'

function TimelineChart(props) {
  const {
    option: optionProp = {},
    format,
    xAxisName,
    xAxisData,
    ...otherProps
  } = props

  const option = {
    ...optionProp,
    title: {
      left: 'center',
      ...optionProp.title
    },
    grid: {
      left: 48,
      right: 48,
      bottom: 32,
      ...optionProp.grid
    },
    xAxis: timeAxis({
      ...optionProp.xAxis,
      name: xAxisName,
      data: xAxisData,
      format
    })
  }

  return (
    <Chart
      {...otherProps}
      option={option}
    />
  )
}

if (process.env.NODE_ENV !== 'production') {
  TimelineChart.propTypes = {
    option: PropTypes.object,
    format: PropTypes.string,
    xAxisName: PropTypes.string,
    xAxisData: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
  }
}

export default TimelineChart



// WEBPACK FOOTER //
// ./src/components/TimelineChart/TimelineChart.js